export function getObjectPropertyValueByKey(obj, key) {
    var map = new Map(Object.entries(obj));
    if (obj.hasOwnProperty(key) && map) {
        return map.get(key);
    }
}
